var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"spinner"},[_c('div',{staticClass:"bounce1",style:('background-color:'+_vm.color)}),_c('div',{staticClass:"bounce2",style:('background-color:'+_vm.color)}),_c('div',{staticClass:"bounce3",style:('background-color:'+_vm.color)})])
}
var staticRenderFns = []

export { render, staticRenderFns }